import { render, staticRenderFns } from "./webhook-manager.vue?vue&type=template&id=fbdeda0a"
import script from "./webhook-manager.vue?vue&type=script&lang=js"
export * from "./webhook-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports